import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { HolidaySelectStateClass } from './interfaces/holidaySelectStateClass';
const initialState: HolidaySelectStateClass = {
    isLoading: false,
    status: 'idle',
    holidaySelectList: [],
    holidaysCheckedlist:[],
    selectedRecord: {},
    isReload : false
}
interface IThunkApi {
    state: {
        holidaySelect: HolidaySelectStateClass;
    },
}
export const getHolidaySelectListAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'holiday/getDataHolidaySelect',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Holidays/GetDataHolidaySelect', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const updateHolidaysAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holiday/updateHolidaysAsync',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Holidays/UpdateHolidays', 'PUT', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


  
export const holidaySelectSlice = createSlice({
    name: 'holiday',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.holidaySelectList.findIndex((item) => item.MasterHolidayTypeId == action.payload);
            const newArray = [...state.holidaySelectList];
            newArray[currentindex] = { ...newArray[currentindex], IsSelected : true };
            state.holidaySelectList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.holidaySelectList.findIndex((item) => item.MasterHolidayTypeId == action.payload);
            const newArray = [...state.holidaySelectList];
            newArray[currentindex] = { ...newArray[currentindex], IsSelected: false };
            state.holidaySelectList = newArray;
        },
    
    },
    extraReducers: (builder) => {
        builder
            .addCase(getHolidaySelectListAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getHolidaySelectListAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.holidaySelectList = payload;               
                state.selectedRecord = {};
            })
            .addCase(getHolidaySelectListAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(updateHolidaysAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateHolidaysAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(updateHolidaysAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })


    }
})
export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState
} = holidaySelectSlice.actions
  export const holidayTypeStateClass = (state: RootState) => state.holidaySelect
 export default holidaySelectSlice.reducer